export default __webpack_public_path__ + "static/media/badge.2e930313.png";